import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Login from "./Login";
import Register from "./Register";
import { images } from "../../assets/images";

const AuthPage: React.FC = () => {
  const [authMode, setAuthMode] = useState<"login" | "register">("login");
  const navigate = useNavigate();

  const handleClose = () => {
    navigate("/");
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 relative overflow-hidden">
      {/* ===== Full Background Image (Fintech themed) ===== */}
      <div className="absolute inset-0 -z-10">
        <img
          src={images.authMockup}
          alt="Fintech Background"
          className="w-full h-full object-cover"
        />
        {/* Dark overlay for readability */}
        <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />
      </div>

      {/* 
                Content Container:
                The form itself will float on the page.
            */}
      <div className="relative w-full max-w-lg animate-in fade-in zoom-in duration-300 flex flex-col max-h-[90vh]">
        {authMode === "login" ? (
          <Login
            isModal={true}
            onClose={handleClose}
            onSwitch={() => setAuthMode("register")}
          />
        ) : (
          <Register
            isModal={true}
            onClose={handleClose}
            onSwitch={() => setAuthMode("login")}
          />
        )}
      </div>
    </div>
  );
};

export default AuthPage;
